import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import { formatLiveTitleCurrencyText, mapUnitToCurrencyCode } from '@sg/pages/StudioManagement/LiveTitles/utils/currencyRules';

export const getFormatNotes = (list: any[], selectedMonthStr: string) => {
  return (list || []).map((item: any) => ({
    game_title: item?.game_title,
    date: selectedMonthStr,
    avatar: item?.cover,
    note: item?.note?.note || '',
    attach: item?.note?.url || [],
  }));
};


export const formatMainValue = (
  num?: number | null,
  formatter?: string,
  unit?: string,
): string => {
  if (num === null || num === undefined || isNaN(num)) {
    return '-';
  }

  let formattedValue: string;
  if (formatter) {
    try {
      const formatRule = (
        formatter === 'thousands2Decimal' || formatter === '0,0.00'
      )
        ? 'db_bm00'
        : formatter;
      const formatted = dataFormat({ value: num, formatRule });
      formattedValue = (
        formatted === null ||
        formatted === undefined ||
        formatted === 'NaN' ||
        (typeof formatted === 'number' && isNaN(formatted))
      )
        ? num.toLocaleString()
        : String(formatted);
    } catch (error) {
      formattedValue = num.toLocaleString();
    }
  } else {
    formattedValue = num.toLocaleString();
  }

  if (unit === 'hour') {
    return `${formattedValue}H`;
  }
  if (unit === 'USD' || unit === 'RMB') {
    return formatLiveTitleCurrencyText(
      formattedValue,
      mapUnitToCurrencyCode(unit),
    );
  }
  return formattedValue;
};
